module.exports = __webpack_public_path__ + "static/media/h270_12.68b5b2a67e92f162d2782f4231f61cd9.png";